module.exports = __webpack_public_path__ + "static/img/li10_1.bb501c70.png";